module.exports = __webpack_public_path__ + "assets/img/s3-tab-3-active-423d9351.png";